import { useTranslation } from 'react-i18next';
import Heading from 'components/Home/Heading';
import useExpanded from 'lib/hooks/useExpanded';
import { Link, Button } from 'components/Home/LinkGridShared';
import topModelsByCityCSS from '../styles/Home/TopModelsByCity';

const DEFAULT_NUM_OF_LISTINGS = 5;
const SEARCH_URLS = Object.freeze([
  {
    makeModel: 'Chevrolet Camaro',
    city: 'Atlanta, GA',
    url: '/chevrolet-camaro-atlanta-ga',
  },
  {
    makeModel: 'Chevrolet Camaro',
    city: 'Houston, TX',
    url: '/chevrolet-camaro-houston-tx',
  },
  {
    makeModel: 'Chevrolet Camaro',
    city: 'Las Vegas, NV',
    url: '/chevrolet-camaro-las+vegas-nv',
  },
  {
    makeModel: 'Chevrolet Camaro',
    city: 'Los Angeles, CA',
    url: '/chevrolet-camaro-los+angeles-ca',
  },
  {
    makeModel: 'Chevrolet Camaro',
    city: 'Miami, FL',
    url: '/chevrolet-camaro-miami-fl',
  },
  {
    makeModel: 'Chevrolet Silverado 1500',
    city: 'Houston, TX',
    url: '/chevrolet-silverado+1500-houston-tx',
  },
  {
    makeModel: 'Dodge Challenger',
    city: 'Atlanta, GA',
    url: '/dodge-challenger-atlanta-ga',
  },
  {
    makeModel: 'Dodge Challenger',
    city: 'Las Vegas, NV',
    url: '/dodge-challenger-las+vegas-nv',
  },
  {
    makeModel: 'Dodge Challenger',
    city: 'Los Angeles, CA',
    url: '/dodge-challenger-los+angeles-ca',
  },
  {
    makeModel: 'Dodge Challenger',
    city: 'Miami, FL',
    url: '/dodge-challenger-miami-fl',
  },
  {
    makeModel: 'Dodge Charger',
    city: 'Atlanta, GA',
    url: '/dodge-charger-atlanta-ga',
  },
  {
    makeModel: 'Dodge Charger',
    city: 'Houston, TX',
    url: '/dodge-charger-houston-tx',
  },
  {
    makeModel: 'Dodge Charger',
    city: 'Los Angeles, CA',
    url: '/dodge-charger-los+angeles-ca',
  },
  {
    makeModel: 'Ford F 150',
    city: 'Las Vegas, NV',
    url: '/ford-f+150-las+vegas-nv',
  },
  {
    makeModel: 'Ford F-150',
    city: 'Houston, TX',
    url: '/ford-f+150-houston-tx',
  },
  {
    makeModel: 'Ford Mustang',
    city: 'Atlanta, GA',
    url: '/ford-mustang-atlanta-ga',
  },
  {
    makeModel: 'Ford Mustang',
    city: 'Houston, TX',
    url: '/ford-mustang-houston-tx',
  },
  {
    makeModel: 'Ford Mustang',
    city: 'Las Vegas, NV',
    url: '/ford-mustang-las+vegas-nv',
  },
  {
    makeModel: 'Ford Mustang',
    city: 'Los Angeles, CA',
    url: '/ford-mustang-los+angeles-ca',
  },
  {
    makeModel: 'Ford Mustang',
    city: 'Miami, FL',
    url: '/ford-mustang-miami-fl',
  },
  {
    makeModel: 'Honda Accord',
    city: 'Los Angeles, CA',
    url: '/honda-accord-los+angeles-ca',
  },
  {
    makeModel: 'Honda Accord',
    city: 'Miami, FL',
    url: '/honda-accord-miami-fl',
  },
  {
    makeModel: 'Honda Civic',
    city: 'Las Vegas, NV',
    url: '/honda-civic-las+vegas-nv',
  },
  {
    makeModel: 'Toyota Corolla',
    city: 'Miami, FL',
    url: '/toyota-corolla-miami-fl',
  },
]);

export default function TopModelsByCity() {
  const [expanded, topRef, toggleExpanded] = useExpanded();
  const linkI18nKey = 'home.topModelsByCity.linkTitle';
  const listSize = expanded ? SEARCH_URLS.length : DEFAULT_NUM_OF_LISTINGS;
  const { t } = useTranslation();

  return (
    <div className="container" ref={topRef}>
      <Heading title={t('home.topModelsByCity.title')} />
      <div className="links" data-testid="links">
        {SEARCH_URLS.slice(0, listSize).map(({ makeModel, city, url }) => {
          const title = t(linkI18nKey, { makeModel, city });

          return (
            <Link key={url} url={url} section={'featured_mmcs'}>
              {title}
            </Link>
          );
        })}
      </div>
      <Button
        expanded={expanded}
        onClick={toggleExpanded}
        section={'featured_mmcs_show'}
      />
      <style jsx>{topModelsByCityCSS}</style>
    </div>
  );
}
